/**
 * [pug template]
 */
<template lang="pug">
  img(:src="src", :alt="name", @click.stop="onClick", @mouseenter="mouseEnter", @mouseOver="mouseOver", @mouseMove="mouseMove", @mouseleave="mouseLeave")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'image-component',
  props: {
    name: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: '#'
    },
    mouseEnter: {
      type: Function,
      default: function () { }
    },
    mouseOver: {
      type: Function,
      default: function () { }
    },
    mouseMove: {
      type: Function,
      default: function () { }
    },
    mouseLeave: {
      type: Function,
      default: function () { }
    },
    onClick: {
      type: Function,
      default: function () { }
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// ImageComponent.vue?4d623489